import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostMitarbeiterCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostMitarbeiterCommandService],
  exports: []
})
export class PostMitarbeiterCommandServiceModule { }
